
import { ENDPOINTS } from 'constants/endpoints';
import { FormErrorMessageSpan, InputMintDiv, SuccessMessageSpan } from 'views/common-styled-components';
import ProfileViewSelector from '../../profile-view.selector';
import { propsToJS } from '__utils/immutable-to-js';
import React, { useState, useEffect } from 'react';
import { getTaxStatus, refreshOnHistoryTraversal } from '__utils/common-utils';
import { SuccessBtnWhiteGreenBorder } from 'components/button';
import { useHistory } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { fetchGetProfileView, fetchGetProfileViewSuccess } from '../../profile-view.actions';
import { getEncryptedUserId } from '__utils/common-utils';
import { getDefaultHeaders, post, get } from '__utils/ajax-wrapper';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import resolveURLParams from '__utils/url-params-resolver';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { Row, Col } from 'antd';
import { LayoutContext } from 'components/app-routes';
import useFlashToggler from 'hooks/use-flash-toggler';
import { PersonalInfoTab, ProfileSubmitButton } from './style';
import { DASHBOARD_PERSONAL_INPUTS, PROFILE_DISCARD_CTA, PROFILE_EDITABLE_FIELDS, PROFILE_EDIT_CTA, PROFILE_ONBOARDING_CTA, PROFILE_SAVE_CTA, PROFILE_TABS } from '../constants';
import _ from 'lodash';
import OtpVerifyPopup from 'components/otp-verification';
import MobileFooterLayout from 'components/old-footer-layout';
import { MY_PROFILE_HEADER } from 'constants/header-titles';
import { EditPenIcon } from 'assets/icons/edit-pen-icon';
import { API_CATCH_MESSAGE } from 'constants/common-constants';

const PersonalAccountInfo: React.FC = () => {
    const history = useHistory();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const dispatch = useDispatch();
    // eslint-disable-next-line
    const { SetLayoutProps } = React.useContext(LayoutContext);
    const { profileView } = propsToJS(useSelector(ProfileViewSelector));
    const { register, handleSubmit, errors, reset, watch } = useForm({ mode: 'onChange', defaultValues: profileView });
    const [pinCodeErr, setPinCodeErr] = useState<boolean>(false);
    const [editEnabled, setEditEnabled] = useState<boolean>(false);
    const [editProfileView, setEditedProfileView] = useState();
    const [isDirty, setIsDirty] = useState<boolean>(false);
    const [showUpdationOTPpopup, setShowUpdationOTPpopup] = useState<boolean>(false);
    const [pinAddress, setPinAddress] = useState<any>();
    const flash = useFlashToggler();

    useEffect(() => {
        SetLayoutProps({
            config: { title: MY_PROFILE_HEADER }
        })
        dispatch(fetchGetProfileView(getEncryptedUserId()));
        Mixpanel.track(getEventName("personalDetails", "loaded", "profile"));
        refreshOnHistoryTraversal(() => window.location.reload());

    }, []);

    //@purpose:- Enable save btn when actual changes are present
    useEffect(() => {
        if (profileView) {
            const edited = { ...profileView, ...watch() };
            setIsDirty(_.isEqual(edited, profileView));
        }
    }, [watch])

    const onEditBtnClick = (event: any) => {
        event.stopPropagation();
        if (profileView?.registeredWithBse !== 3) {
            history.push('/profile/kyc-details?flowType=checkout');
            setEditEnabled(false);
        }
        else
            setEditEnabled(true);
    }

    const discardChanges = () => {
        setEditEnabled(false);
        reset({});
        setPinAddress({});
        setPinCodeErr(false);
    }
    const getDefaultValue = (inputName: string) => {
        if (profileView) {
            if (inputName === 'dob') return profileView?.dob ? moment(profileView?.dob)?.format('DD/MM/YYYY') : undefined
            else if (inputName === 'taxStatus') return getTaxStatus(profileView?.taxStatus)
            else return profileView[inputName]
        }
        else return undefined;

    }

    const validatePincode = (pincode: any) => {
        setPinAddress(false); setPinCodeErr(false);
        if (pincode) {
            get(resolveURLParams(ENDPOINTS.GET_VERIFY_PINCODE, { pincode: pincode }, null),
                getDefaultHeaders(),
                true
            ).subscribe((response: AjaxResponse | AjaxError) => {
                if (response?.response?.operationMessage === "true") {
                    setPinCodeErr(false);
                    setPinAddress({ ...pinAddress, city: response?.response?.responseData?.city, state: response?.response?.responseData?.state });
                }
                else if (response?.response?.operationMessage === 'false') {
                    setPinCodeErr(true);
                }

            }, (error: AjaxError) => {
                flash.error("Pincode validation Failed. Please try again later.")
            });
        }
    };

    const getProfileUpdationOTP = () => {
        post(
            `${ENDPOINTS.POST_PROFILE_UPDATION_OTP}?encryptedId=${getEncryptedUserId()}`,
            null,
            getDefaultHeaders(),
            true
        ).subscribe((response: AjaxResponse | AjaxError) => {
            setShowUpdationOTPpopup(true);
        }, (error: AjaxError) => {
            flash.error(API_CATCH_MESSAGE);
        });
    }

    const getVerifyOTP = (otp: any) => {
        post(`${ENDPOINTS.POST_PROFILE_UPDATION_VERIFY_OTP}?encryptedId=${getEncryptedUserId()}&otp=${otp}`, null, getDefaultHeaders(), true)
            .subscribe((response: any) => {
                if (response && response.response?.data?.otpMatched && !response.response?.data?.expired) {
                    setShowUpdationOTPpopup(false);
                    updatePersonalDetails();
                }
                else {
                    flash.error(response?.response?.meta?.error ?? API_CATCH_MESSAGE);
                }
            }, (error: AjaxError) => {
                flash.error(API_CATCH_MESSAGE);
            });
    }

    const updatePersonalDetails = () => {
        setEditEnabled(false);
        post(resolveURLParams(ENDPOINTS.UPDATE_SAVE_PROFILE_DETAILS, {}, { ucc: getEncryptedUserId() }), editProfileView, getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {
                if (response?.response?.meta?.message === 'success') {
                    flash.success("Changes are made successfully.");
                    Mixpanel.track(getEventName("updatePersonalDetails", "completed", "profile"));
                    dispatch(fetchGetProfileViewSuccess(response?.response?.data));
                }
                else {
                    flash.error(response?.response?.meta?.error);
                }
            }, (error: AjaxError) => {
                flash.error(API_CATCH_MESSAGE);
            });
    }

    const onSubmitPersonalDetails = (data: any) => {
        if (!pinCodeErr) {
            setEditedProfileView({ ...profileView, ...data });
            getProfileUpdationOTP();
        }
    };

    return (<PersonalInfoTab>
        {isMobile && <div className='disp-flex justify-space-between'>
            <h3>{PROFILE_TABS[0].label}</h3>
            {profileView?.registeredWithBse === 3 && <p className={editEnabled ? 'disabledEdit' : 'editP'} onClick={onEditBtnClick}><EditPenIcon disabled={editEnabled} />&nbsp;  Edit Details</p>}
        </div>}
        <form name="personalDetailsForm" onSubmit={handleSubmit(onSubmitPersonalDetails)}>
            <Row gutter={[32, 16]} className={editEnabled ? 'trans-disabled' : ''}>
                {
                    DASHBOARD_PERSONAL_INPUTS.map((inputElement, index) =>
                    (<Col xs={24} md={12} key={index}>
                        <InputMintDiv>
                            <label>{inputElement.title}</label>
                            <br />
                            <input
                                {...inputElement}
                                defaultValue={profileView && getDefaultValue(inputElement.name)}
                            />
                        </InputMintDiv>
                    </Col>
                    ))
                }
                <Col xs={24} md={12}>
                    <InputMintDiv>
                        <label>{PROFILE_EDITABLE_FIELDS.emailField.title}</label>
                        <br />
                        <input
                            name="primaryEmail"
                            {...PROFILE_EDITABLE_FIELDS.emailField}
                            disabled={!editEnabled}
                            defaultValue={profileView?.primaryEmail}
                            ref={register(PROFILE_EDITABLE_FIELDS.emailField.rules)}
                        />
                        {errors?.primaryEmail ? <FormErrorMessageSpan>{errors?.primaryEmail?.message}</FormErrorMessageSpan> : null}
                    </InputMintDiv>
                </Col>
                <Col xs={24} md={12}>
                    <InputMintDiv>
                        <label>{PROFILE_EDITABLE_FIELDS.addressField.title}</label>
                        <br />
                        <input
                            name="address"
                            {...PROFILE_EDITABLE_FIELDS.addressField}
                            defaultValue={profileView?.address}
                            disabled={!editEnabled}
                            ref={register(PROFILE_EDITABLE_FIELDS.addressField.rules)}
                        />
                        {errors?.address ? <FormErrorMessageSpan>{errors?.address.message}</FormErrorMessageSpan> : null}
                    </InputMintDiv>
                </Col>
                <Col xs={24} md={12}>
                    <InputMintDiv>
                        <label>{PROFILE_EDITABLE_FIELDS.pinField.title}</label>
                        <br />
                        <input
                            name="pincode"
                            {...PROFILE_EDITABLE_FIELDS.pinField}
                            defaultValue={profileView?.pincode}
                            disabled={!editEnabled}
                            ref={register(PROFILE_EDITABLE_FIELDS.pinField.rules)}
                            onKeyUp={(e: any) => { setPinCodeErr(false); setPinAddress(false); }}
                            onBlur={(e: any) => { validatePincode(e.target.value) }}
                        />
                        {errors.pincode ? <FormErrorMessageSpan>{errors.pincode.message}</FormErrorMessageSpan> :
                            pinCodeErr ?
                                <FormErrorMessageSpan>Invalid pincode</FormErrorMessageSpan>
                                : pinAddress && <SuccessMessageSpan>{pinAddress?.city}, {pinAddress?.state}</SuccessMessageSpan>

                        }
                    </InputMintDiv>
                </Col>
            </Row>


            <div className='account-btn-wrapper'>
                {editEnabled ? <>
                    <SuccessBtnWhiteGreenBorder onClick={discardChanges} className="accountBtn">{PROFILE_DISCARD_CTA} </SuccessBtnWhiteGreenBorder>
                    <ProfileSubmitButton isMobile={isMobile} type="submit" disabled={isDirty}>{PROFILE_SAVE_CTA}</ProfileSubmitButton>
                </> :
                    <>
                        {(profileView?.registeredWithBse !== 3 || !isMobile) && <ProfileSubmitButton onClick={(event: any) => onEditBtnClick(event)} isMobile={isMobile} type="button">{profileView?.registeredWithBse !== 3 ? PROFILE_ONBOARDING_CTA : PROFILE_EDIT_CTA}</ProfileSubmitButton>}
                    </>
                }
            </div>

        </form>
        {
            showUpdationOTPpopup && <OtpVerifyPopup
                className="otpContainer"
                inputClassName="otpInput"
                onVerifyOtp={getVerifyOTP}
                onResendOtp={getProfileUpdationOTP}
                submitBtnCTA='Verify & Proceed'
            ></OtpVerifyPopup>
        }
        <MobileFooterLayout />
    </PersonalInfoTab >
    );
};

export default PersonalAccountInfo
